import { useMutation } from '@tanstack/react-query';
import { POST, POST_ADD_BRAND } from '../../../../services';
import { openAlert } from '../../../../components/alert/hooks';
import { InsertBrand } from '../../../../resources/payload';

export const useInsertBrand = ({ onSuccessCallBack }) => {
  return useMutation({
    mutationFn: async (values) => {
      const formData = new FormData();
      const payload = InsertBrand(values);

      Object.entries(payload).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      const response = await POST(POST_ADD_BRAND(), formData);
      if (onSuccessCallBack) onSuccessCallBack(response);

      return response;
    },
    onSuccess: () => {
      openAlert({
        model: 'message',
        type: 'success',
        message: 'เพิ่ม Brand สำเร็จ',
      });
    },
  });
};
